<template>
  <div class="container">
    <div class="card">
      <div id="logo">
        <img src="../../assets/KeepNeye.png" width="100" height="100" alt="">
      </div>
      <transition name="fade" mode="out-in">
        <div v-if="!forgot" class="card-block" key="authenticate">
          <div class="row">
            <regular-input 
              :value="username"
              @input="username = $event; wrgUser = false"
              :error="wrgUser"
              type="text" :placeholder="$t('login.username')" class="col-12 form-group"/>
            <regular-input
              :value="password" 
              @input="password = $event; wrgPass = false"
              @enter="authenticate()"
              :error="wrgPass"
              type="password" :placeholder="$t('login.password')" class="col-12 form-group"/>
          </div>
          <p class="form-group">
            <a href="" @click.prevent="forgot = true">
              {{ $t('login.forgot') }}
            </a>
          </p>
          <button @click="authenticate()" class="btn btn-kne-orange col-12">
            {{ $t('login.submit') }}
          </button>
        </div>
        <div v-if="forgot" class="card-block" key="forgot">
          <div class="row">
            <regular-input 
              :value="username"
              @input="username = $event; wrgUser = false"
              :error="wrgUser"
              :success="emailSent"
              type="text" :placeholder="$t('login.username')" class="col-12 form-group"/>
          </div>
          <p class="form-group">
            <a href="" @click.prevent="forgot = false">
              {{ $t('login.authenticate') }}
            </a>
          </p>
          <button @click="reset()" class="btn btn-kne-orange col-12">
            {{ $t('login.reset') }}
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import regularInput from '../regularInput.vue'
import Firebase from 'firebase'
import router from '../../router'
import {db} from '../../firebase'

export default {
  name: 'login',
  components: {
    regularInput
  },
  data () {
    return {
      username: '',
      password: '',
      wrgUser: false,
      wrgPass: false,
      forgot: false,
      emailSent: false
    }
  },
  methods: {
    authenticate () {
      Firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(async (user) => {
        this.$store.commit('setUser', user || false)
        if (user !== null) {
          let authorize
          await db.ref('users/transportersman').child(user.uid).once('value').then((snapshot) => {
            snapshot.val() === null ? authorize = false : authorize = true; this.$store.commit('setAuthorization', snapshot.val())
          })
          if (!authorize) {
            console.log('User not authorized')
            this.wrgUser = true
            this.signOut()
            return
          }
          db.ref('users/transporters').child(this.$store.state.authorization.company).once('value').then((snapshot) => {
            this.$store.commit('setUserInfo', snapshot.val())
            if (snapshot.val().language === undefined || snapshot.val().language === '') this.$i18n.set('en')
            else this.$i18n.set(snapshot.val().language)
          })
          if (user.uid !== 'e58ff614-8449-4c3e-90b8-b42a48c2972b') this.$store.commit('initAllContact')
        }
        this.$route.query.redirect ? router.push({path: this.$route.query.redirect}) : router.push({path: '/dashboard'})
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        if (errorCode === 'auth/invalid-email') this.wrgUser = true
        if (errorCode === 'auth/user-not-found') this.wrgUser = true
        if (errorCode === 'auth/wrong-password') this.wrgPass = true
        console.log(errorCode)
        console.log(errorMessage)
        // ...
      })
    },
    reset () {
      Firebase.auth().sendPasswordResetEmail(this.username).then(() => {
        this.emailSent = true
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        if (errorCode === 'auth/invalid-email') this.wrgUser = true
        console.log(errorCode)
        console.log(errorMessage)
        // ...
      })
    },
    signOut () {
      Firebase.auth().signOut().then(() => {
        this.$store.commit('clearUser')
        this.$store.commit('clearContacts')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  #logo {
    padding-top: 1.25rem;
  }
  img {
    margin-bottom: 2rem;
  }
  .card {
    margin-top: 3rem;
    text-align: center;
  }
  @media (min-width: 574px) {
    .card {
      margin-right: 0rem;
      margin-left: 0rem;
    }
  }
  @media (min-width: 766px) {
    .card {
      margin-top: 10rem;
      margin-right: 8rem;
      margin-left: 8rem;
    }
  }
  @media (min-width: 990px) {
    .card {
      margin-top: 10rem;
      margin-right: 15rem;
      margin-left: 15rem;
    }
  }
  @media (min-width: 1198px) {
    .card {
      margin-top: 10rem;
      margin-right: 15rem;
      margin-left: 15rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?2d581f3d